import { History } from 'history'
import { resolveNavigateTargetOrThrow } from 'util/navigateUtils'
import { AdaAction } from '../actions'

export async function handleNavigate(action: AdaAction, history: History) {
  const target = resolveNavigateTargetOrThrow({
    pathname: action.args.pathname ?? null,
    url: action.args.url ?? null,
  })
  history.push(target)
}
